import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {
}

@Component({
    selector: 'lockton-apps-textarea-field-type',
    templateUrl: './textarea-field-type.component.html',
    styleUrls: ['./textarea-field-type.component.scss'],
    standalone: false
})
export class TextareaFieldTypeComponent extends FieldType<FieldTypeConfig<InputProps>> {
}
